export default __webpack_public_path__ + "static/media/mustang.b3cdb0a7.jpg";